export const events = {
  eventsCardDurationText: 'trukmė',
  eventsSearchInputText: 'Paieška',
  eventsRegisteredToEventAlertTitle: 'Sėkmingai užsiregistravote',
  eventsUnregisteredToEventAlertTitle: 'Registracija atšaukta',
  eventsExternalRegistrationPopupTitle: 'Registracija',
  eventsExternalRegistrationPopupContent: 'Ar sėkmingai užsiregistravote?',
  eventsExternalRegistrationNoButtonTitle: 'Ne',
  eventsExternalRegistrationYesButtonTitle: 'Taip',
  eventsCurtainCopyOptionTitle: 'Kopijuoti nuorodą',
  eventsCurtainFlagOptionTitle: 'Pažymėti turinį',
  eventsLinkCopiedAlertText: 'Nuoroda nukopijuota!',
  eventsCurtainAddToCalendOptionTitle: 'Pridėti į kalendorių',
  eventdetailsAgendaButtonTitle: 'Programa',
  eventdetailsOnMapButtonTitle: 'Žemėlapis',
  eventdetailsOnlineLocationTitle: 'Internetu',
  eventdetailAmountsRegisteredText: 'Dalyviai',
  eventdetailsSeeAllButtonTitle: 'Rodyti visus',
  eventdetailsRegisteredButtonTitle: 'Užsiregistruota',
  eventdetailsRegisterButtonTitle: 'Registruotis',
  eventdetailsRegisteredAlertText: 'Sėkmingai užsiregistravote',
  eventdetailsUnregisteredAlertText: 'Registracija atšaukta',
  eventdetailsAgendaTitle: 'Programa',
  eventdetailsSeeAllRegisteredCurtainTitle: 'Užsiregistravę vartotojai',
  eventdetailsSpeakersCurtainTitle: 'Pranešėjai',
  eventdetailsSpeakersSectionTitle: 'Pranešėjai',
  eventdetailsSpeakersSectionSeeAllButtonTitle: 'Rodyti visus',
  eventdetailsCustomSectionSeeAllButtonTitle: 'Rodyti visus',
  eventdetailsCurtainCopyOptionTitle: 'Kopijuoti nuorodą',
  eventdetailsCurtainFlagOptionTitle: 'Pažymėti turinį',
  eventsdetailsLinkCopiedAlertText: 'Nuoroda nukopijuota!',
  eventdetailsCurtainAddToCalOptionTitle: 'Pridėti į kalendorių',
  eventDetailsAddCalendarPopupTitle: 'Kalendorius',
  eventdetailsAddCalendarPopupContent: 'Pridėti į kalendorių?',
  eventdetailsAddCalendarPopupNoButtonTitle: 'Ne',
  eventdetailsAddCalendarPopupYesButtonTitle: 'Taip',
  eventdetailsSpeakerCurtainCopyOptionTitle: 'Kopijuoti nuorodą',
  eventdetailsSpeakerCurtainFlagOptionTitle: 'Pažymėti turinį',
  eventsdetailsSpeakersLinkCopiedAlertText: 'Nuoroda nukopijuota!',
  eventdetailsCustomSectionCurtainCopyOptionTitle: 'Kopijuoti nuorodą',
  eventdetailsCustomSectionCurtainFlagOptionTitle: 'Pažymėti turinį',
  eventsFlag: 'Pažymėti',
  eventsJoin: 'Prisijungti',
  eventdetailsCustomSectionLinkCopiedAlertText: 'Nuoroda nukopijuota!',
  eventContentReported: 'Turinys pažymėtas',
  eventsError: 'Įvyko klaida!',
  eventdetailsExternalRegistrationPopupContent: 'Ar sėkmingai užsiregistravote?',
  eventdetailsExternalRegistrationNoButtonTitle: 'Ne',
  eventdetailsExternalRegistrationYesButtonTitle: 'Taip',
  eventdetailsExternalRegistrationPopupTitle: 'Registracija',
  eventsCardRegisteredButtonTitle: 'Užsiregistruota',
  eventsCardRegisterButtonTitle: 'Registruotis',
  eventsJoinLink: 'Prisijungimo nuoroda: [url]{link}[/url][br]',
  eventsGuest: 'Svečias',
  eventsNoSessionInDay: 'Tą dieną nėra renginių.',
  eventsShowUpcomingEvent: 'Rodyti artėjantį renginį'
}
